import _isString from 'lodash-es/isString';
import _get from 'lodash-es/get';
import _isNumber from 'lodash-es/isNumber';
import _isObject from 'lodash-es/isObject';
import _keys from 'lodash-es/keys';

import * as moment from 'moment';

import { Yii } from "libraries/interfaces/Yii";

import { faArrowRight, IconDefinition, faStar, faClock } from "@fortawesome/free-solid-svg-icons";

/**
 * sector component
 */
import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

//service
import { DateService } from '../date/date.service';
import { ISector } from 'libraries/service/resources/airTrip/IGetAirTripQuotes';
import { ILabels } from "libraries/interfaces/ILabels";
import { LanguageService } from "libraries/service/language/language.service";
import { ICarbonFootPrint } from "libraries/component/carbon-footprint/carbon-footprint.interface";


@Component({
    selector: 'sector',
    templateUrl: "./sector.html",
    styles: [`
        :host {
            width: unset;
        }
        .sector {
            display: flex;
            padding-left: 10px;
            padding-right: 10px;
            justify-content: unset;
            width: unset;
        }

        .from-to {
            display: flex;
        }

        .from-to-part-arrow {
            padding: 0 .2em;
        }

        .sector-part.duration,
        .sector-part.departure {
            white-space: nowrap;
        }

        .sector-part.departure {
            min-width: 120px;
            margin-right: 10px;
        }
        .lang-en .sector-part.departure {
            min-width: 140px;
        }
        .sector-part.from-to {
            min-width: 120px;
        }
        .lang-en .sector-part.from-to {
            min-width: 160px;
        }
        .sector-part.duration {
            min-width: 80px;
        }
        .sector-part.carrier {
            min-width: 60px;
        }

        .sector-stop {
            display: flex;
            justify-content: center;
            flex-direction: column;
            align-items: center;
            margin: 5px 5px 20px 5px;
            width: auto;
        }

        .sector-stop .duration {
            background: white;
            color: grey;
            font-size: .8rem;
            border: 1px solid grey;
            border-radius: 5px;
            padding: .2rem;
            position: relative;
            z-index: 3;

        }

        .sector-stop .deco {
            width: 60%;
            border-bottom: 1px dashed grey;
            margin-top: -.7rem;
            position: relative;
        }

        em {
            font-weight: normal;
            color: grey;
            font-style: normal;
        }

        .carbon-footprint {
            margin-left: .75rem;
        }


    `]
})
export class SectorComponent implements OnChanges {
    @Input()
    public sectorItem: any;
    @Input()
    public selectedSector: ISector;
    @Input()
    public begindate: string;
    @Input()
    public type: any;
    @Input()
    public selectedIndex: string;
    @Input()
    public index: string;
    @Input()
    public carrier: any;
    @Input()
    public key: boolean = false;

    public iconArrowRight: IconDefinition = faArrowRight;

    public iconStar: IconDefinition = faStar;

    public iconClock: IconDefinition = faClock;

    public showCarbonFootprint: boolean;
    public readonly labels: ILabels = {
        classCode: Yii.t('wui-shared-js', 'Classe :'),
        operatedBy: Yii.t('wui-shared-js','Op.')
    };

    public dayDiff: number | string;

    public carbonReferenceValue: ICarbonFootPrint = null;

    constructor(
        public readonly dateService: DateService,
        public readonly languageService: LanguageService
    ) {
    }

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes && changes.sectorItem && changes.sectorItem.currentValue) {
            if (this.sectorItem.end
                && this.sectorItem.end.offset
                && this.sectorItem.end.offset.day
                && this.sectorItem.end.offset.origin === "sector") {
                this.dayDiff = this.sectorItem.end.offset.day > 0
                    ? `+${this.sectorItem.end.offset.day}`
                    : this.sectorItem.end.offset.day;
            } else if (this.sectorItem.end) {
                this.dayDiff = this.dateService.dayDifference(this.sectorItem.begin, this.sectorItem.end);
            }
            //carrier in PNR is string, so convert it
            if (_isString(this.sectorItem.carrier)) {
                const copy = this.sectorItem.carrier;
                this.sectorItem.carrier = {};
                this.sectorItem.carrier.code = copy;
            }
        }
        if (changes && changes.selectedSector && changes.selectedSector.currentValue) {
            this.initCarbonReferenceValue(changes.selectedSector.currentValue);
        }
    }

    /**
     * function that handle the différences of the data format
     * @method getAirportCode
     * @param  airportContext the airport field Input
     * @return {String} the airport code
     */
    public getAirportCode(airportContext: any): string {
        let codeReturn: string;
        if (airportContext && !_isString(airportContext)) {

            if (airportContext.code && _isString(airportContext.code)) {
                codeReturn = airportContext.code;
            }
            if (airportContext.airport && airportContext.airport.code && _isString(airportContext.airport.code)) {
                codeReturn = airportContext.airport.code;
            }

        } else {
            codeReturn = airportContext;
        }
        return codeReturn;
    }

    public getClassCode(): string | boolean {
        if (this.sectorItem && this.sectorItem.seat) {
            if (_isObject(this.sectorItem.seat)) {
                return this.sectorItem.seat.code;
            } else {
                if (this.sectorItem.seat === " ") {
                    return false;
                } else {
                    return this.sectorItem.seat.code;
                }
            }
        }
        return false;
    }

    public getDate(date: { date: string, time: string } | string): string {
        if (typeof date === "string") {
            return date;
        }

        return `${date.date} ${date.time}`;
    }

    public isValidDate(date: { date: string, time: string } | string): boolean {
        return date && (typeof date === "string" || Boolean(date.date) && Boolean(date.time));
    }

    public setDateFromOffset(): string {
        let dateReturnValue: string | moment.Moment;
        const day = _get(this.sectorItem, ['begin', 'offset', 'day']);
        // need to assume all date location eventualities :
        const dayFromBegin = _get(this.sectorItem, "begin");
        const dayFromBeginDate = _get(this.sectorItem, ["begin", "date"]);

        if (day) {
            if (_isNumber(day) && this.begindate) {
                dateReturnValue = day === 0 ?
                    this.begindate :
                    moment(this.begindate).add(day, 'd');
            } else {
                dateReturnValue = this.sectorItem.begin;
            }
            return dateReturnValue as string;
        }

        return dayFromBeginDate ? dayFromBeginDate : dayFromBegin;
    }

    private initCarbonReferenceValue(selectedSector: ISector): void {
        this.carbonReferenceValue = selectedSector.carbonFootprint;
    }
}
